const getRecognitionPath = (recognition) => (recognition && "uuid" in recognition
  ? `polls/recognition/${recognition.uuid}`
  : null)

const getPollPath = (poll) => (poll && "uuid" in poll
  ? `polls/poll/${poll.uuid}`
  : null)

export {
  getRecognitionPath,
  getPollPath
}
